import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label } from "reactstrap";

import api from "../../../utility/api/api";
import { delayReasonAction } from "../../../actions";

class DelayReasonModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedReason: null,
            loading: false,
            errorMessage: "",
        };
    }

    componentWillMount() {
        api.delayreasonsList(this);
    }

    handleReasonChange = (reasonId) => {
        this.setState({ selectedReason: reasonId });
    };

    handleOkClick = (e) => {
        if (this.state.selectedReason) {
            const selectedReasonObj = this.props && this.props.delayData && this.props.delayData[0].data &&
                this.props.delayData[0].data.reasons.find(
                    (r) => r.reason === this.state.selectedReason
                );
            this.props.onReasonSubmit(e, selectedReasonObj);
            this.resetModal();
        }
    };

    resetModal = () => {
        this.setState({
            selectedReason: null,
            errorMessage: "",
        });
    };

    render() {
        const { selectedReason, loading, errorMessage } = this.state;
        const { isOpen, errorMsg } = this.props;

        return (
            <Modal isOpen={isOpen} centered
                fade={false} backdrop={"static"}
            >
                <ModalHeader className="bg-light border-bottom">
                    <span className="font-weight-bold text-dark">Reason for Delay</span>
                </ModalHeader>
                <ModalBody className="p-4">
                    <div className="mb-3">
                        <p className="text-danger font-weight-500 p-2 bg-light border-left border-danger">
                            <i className="fa fa-exclamation-circle mr-2"></i>
                            {`${errorMsg || "Your delivery slot has expired. Please select a reason for the delay"}: ` + this.props.delay_time}
                        </p>
                    </div>
                    <div className="select-reason-title">Select Reason</div>
                    <div className="delay-reasons-section mt-3">
                        {loading ? (
                            <p className="text-center text-muted">Loading reasons...</p>
                        ) : (
                            <div className="reasons-list">
                                {this.props && this.props.delayData &&
                                    this.props.delayData[0].data &&
                                    this.props.delayData[0].data.reasons.map((obj, index) => (
                                        <div key={index} className="mb-2" style={{ cursor: "pointer" }}>
                                            <input
                                                type="radio"
                                                name="delayReason"
                                                value={obj.reason}
                                                id={`reason-${obj.reason}`}
                                                className="with-gap custom-check"
                                                checked={selectedReason === obj.reason}
                                                onChange={() => this.handleReasonChange(obj.reason)}
                                            />
                                            <Label htmlFor={`reason-${obj.reason}`}>{obj.reason}</Label>
                                        </div>
                                    ))}
                            </div>
                        )}
                    </div>

                    {errorMessage && (
                        <div className="alert alert-danger mt-3 mb-0" role="alert">
                            <small>{errorMessage}</small>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter className="bg-light border-top">
                    <Button
                        onClick={() => {
                            this.resetModal();
                            this.props.onClose();
                        }}
                        className="font-weight-500"
                    >
                        Cancel
                    </Button>
                    <Button
                        color="danger"
                        onClick={this.handleOkClick}
                        disabled={!selectedReason}
                        className="font-weight-500"
                    >
                        Submit
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
function mapStateToProps(state) {
    return {
        delayData: state.getdelayreasons,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            delayReasonAction: delayReasonAction,
        },
        dispatch
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(DelayReasonModal);



// WEBPACK FOOTER //
// ./src/components/Intransit/DeliverOrder/DelayReasonModal.js